import moment from "moment-jalaali";
export function convertToTimestamp(normalDate) {
    const jalaliMoment = moment(normalDate, 'jYYYY/jM/jD----hh:mm:ss a');

    // Convert moment object to timestamp
    const timestamp = jalaliMoment.valueOf();
  
    return timestamp/10000;
}